import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isNativeFeatureEnabled } from 'mini-host-bridge/lib/utils/isNativeFeatureEnabled';

export const isThemingEnabled = () => {
    const isThemingFlightEnabled =
        isMiniFeatureEnabled('mini-themes') || isMiniFeatureEnabled('mini-t20wc-campaign');
    if (isMiniHostAppFeatureEnabled('nativeHost')) {
        return (
            isMiniHostAppFeatureEnabled('themes') &&
            isNativeFeatureEnabled('themes') &&
            isThemingFlightEnabled
        );
    } else {
        return isThemingFlightEnabled;
    }
};

export const isT20WorldCupThemingEnabled = () => {
    return isMiniFeatureEnabled('mini-t20wc-campaign') && isThemingEnabled();
};

export const isSportsThemingEnabled = () => {
    return isConsumer() && isThemingEnabled();
};
